import { render, staticRenderFns } from "./NotificationContent.vue?vue&type=template&id=8d881d9c&scoped=true&"
import script from "./NotificationContent.vue?vue&type=script&lang=ts&"
export * from "./NotificationContent.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationContent.vue?vue&type=style&index=0&id=8d881d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d881d9c",
  null
  
)

export default component.exports